<div class="modal-body p-md-5">

    <button type="button" class="close" (click)="close()"><i class="icon-close"></i></button>
    <h2 class="mg-b10 font-24 montserrat-medium">Quick guide</h2>

    <!-- <iframe style="width: 100%; height: 70vh; border: none;" src="assets/pdf/How_To_Guide_Audio_Responses.pdf#zoom=90"></iframe> -->
    <!-- <iframe type="application/pdf" style="width: 100%; height: 70vh; border: none;" scrolling="auto" [src]="url | safeHtml"></iframe> -->
    <div style="width: 100%; height: 70vh; border: none;">
        <ng2-pdfjs-viewer [pdfSrc]="url"></ng2-pdfjs-viewer>
    </div>

</div>